export default __webpack_public_path__ + "static/media/escalera1.794cb76e.png";